module.exports = __webpack_public_path__ + "media/ambient.00df5e2b.mp3";